import Title from "../../Title"
import Spinner from "../VideoShare/Spinner"

const Processing = () => (
  <div
    css={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: 8,
      flex: 1,
    }}
  >
    <Spinner />
    <Title title="Processing video..." />

    <p
      css={{
        margin: 0,
        color: "#F2F3F5",
        fontSize: 17,
        textAlign: "center",
      }}
    >
      We promise it’s worth the wait!
    </p>
  </div>
)

export default Processing
